import { notify } from "./index";

export const urls = {
  prod: `wss://rugdoctor.easyforms.tech/ws`,
  dev: "ws://localhost:48219"
};

export class socket {
  constructor({ url }) {
    if (!url) throw new Error("Must provide a url");
    this.url = url;
    this.websocket = {};
  }

  open() {
    this.websocket = new WebSocket(this.url);
    this.websocket.onmessage = this.onmessage;
  }

  close() {
    if (!this.websocket || !this.websocket.close)
      throw new Error("Must have a websocket to close");
    this.websocket.close();
  }

  onmessage(event) {
    console.log(event);
    try {
      notify(event.data, "info");
    } catch (err) {
      console.error("Error dealing with event", event, err);
    }
  }
}



// WEBPACK FOOTER //
// ./src/backend/notifications.js